export default "__VITE_ASSET__BYtd9CI0__"